{
    "ChartprovideroptionsHighcharts": "Grafici alti",
    "ChartprovideroptionsAmcharts": "Grafici AM",
    "NAME": "ChartProviderOptions"
}